import { db } from '@smart-maps/firebase';

import { APP_MAP_ID, EVENT_TYPES } from '../../constants';

export const loadMarkers = user => dispatch => {
  const refs = ['pois'];
  if (user && user.uid) {
    refs.push(`done/${user.uid}`);
  }
  const promises = refs.map(str => db.all(`${APP_MAP_ID}/${str}`));
  return Promise.all(promises)
    .then(results =>
      results.reduce((acc, arr, index) => {
        const [key] = refs[index].split('/');
        return { ...acc, [key]: arr || [] };
      }, {})
    )
    .then(payload =>
      dispatch({
        payload,
        type: EVENT_TYPES.MARKERS_LOADED,
      })
    );
};

export const deleteMarker = (id, user) => dispatch => {
  const refs = ['pois'];
  if (user && user.uid) {
    refs.push(`done/${user.uid}`);
  }
  const promises = refs.map(str => db.remove(id, `${APP_MAP_ID}/${str}`));
  return Promise.all(promises).then(() =>
    dispatch({
      payload: id,
      type: EVENT_TYPES.MARKER_DELETE,
    })
  );
};

export const commitMarker = marker => dispatch => {
  const { id } = marker;
  return db.create(id, `${APP_MAP_ID}/pois`, marker).then(() => {
    dispatch({
      payload: marker,
      type: EVENT_TYPES.MARKER_COMMIT,
    });
  });
};
